<template>
    <div v-if="isAuth" class="profile-link">
        <a :href="$getSubdomainLink('portal', '/my-profile/personal-info')" class="btn btn-primary">
            My profile
        </a>
    </div>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
  name: "ProfileLink",
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
  computed: {
    isAuth() {
      return this.authStore.isAuth;
    },
  },
};
</script>
